import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=food；独立窗 app 经路径/别名归一为 repast */
export const cateringModule: AiAppCenterModule = {
  key: 'repast',
  label: 'AI智慧餐饮',
  desc: '门店管理 / 商品订单 / 核销营销',
  path: '/ai-Application-center/catering',
  standalonePath: '/ai-Application-center/catering/dashboard',
  homePath: '/ai-Application-center/catering/dashboard',
  // 兼容裸路径 /catering 与中心前缀路径（后端菜单两种都可能出现）
  menuPaths: ['/catering', '/ai-Application-center/catering'],
  icon: 'ep:food',
  color: '#f97316',
  aliases: ['AI 智慧餐饮', '智慧餐饮', 'AI智慧餐饮', '餐饮管理', '餐饮系统']
}
